// src/config/credentials.ts
const env = import.meta.env as Record<string, string> & { DEV: boolean };

const credentials = {
  isDevelopment: env.DEV,
  s3: {
    region: env.VITE_AWS_REGION || env.VITE_CONTRACT_AWS_REGION || '',
    bucketName: env.VITE_S3_BUCKET || env.VITE_CONTENT_S3_BUCKET || '',
    accessKeyId: env.VITE_AWS_ACCESS_KEY || env.VITE_CONTRACT_AWS_ACCESS_KEY || '',
    secretAccessKey: env.VITE_AWS_SECRET_KEY || env.VITE_CONTRACT_AWS_SECRET_KEY || '',
    dirName: env.VITE_S3_DIR_NAME || 'media',
  },
  googleMapsApiKey: env.VITE_GOOGLE_MAPS_API_KEY || '',
  contractFilename: env.VITE_CONTRACT_S3_FILENAME_BFF || '',
  baseUrl: env.VITE_BASE_URL || '',
  mqtt: {
    url: env.VITE_MQTT_URL || '',
    username: env.VITE_MQTT_USERNAME || '',
    password: env.VITE_MQTT_PASSWORD || '',
  },
};

export default credentials;
